import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../base";

function FormSelectPreview({ ...props }) {
  return <BasePreview {...props}>
    <select>
      <option value="option-1">Option 1</option>
      <option value="option-2">Option 2</option>
      <option value="option-3">Option 3</option>
    </select>
  </BasePreview>
}

export default define('form-select', FormSelectPreview, Fragment)
  .shared(prop.share('FormSelect', 'form-select'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    space: {
      padding: 'pt-1 pb-1 pl-2 pr-2',
    },
    border: {
      radius: {
        rounded: "sm",
      },
      width: {
        border: "1",
      },
      color: "gray-400",
    },
    size: {
      width: "w-full",
      height: "min-h-8",
    },
  })
  .build()

